import axios from 'axios'

export default {
  methods: {
    /**
     * Queries all data from the visits controller of the backend API and returns a list of the most recent usages of the device by unique user, device, or company. The data is then formatted into an object array and passed to the 'userActivity' data property, which is then rendered in a bootstrap-vue table component.
     * @param {string} type - The type of device usage by user, device, or company.
     */
    getAllRecentUsage (type) {
      let self = this

      let urlType = ''

      if (type === 'USER') {
        urlType = '/by_user/' + this.$route.params.id
      } else if (type === 'DEVICE') {
        urlType = '/by_device/' + this.$route.params.id
      } else if (type === 'COMPANY') {
        urlType = '/by_company/' + this.$route.params.id
      }

      axios.get(`${process.env.VUE_APP_API_URL}api/visits/recent_usage${urlType}/all`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data

          let newData = []

          for (let i = 0; i < data.length; i++) {
            newData.push({
              user: {
                name: data[i].first_name + ' ' + data[i].last_name,
                registered: data[i].date_created,
                new: data[i].times_used <= 1
              },
              usage: { times_used: data[i].times_used },
              activity: data[i].last_used
            })
          }

          self.userActivity = newData
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Queries data from the visits controller of the backend API and returns a list of the most recent usages of the device by unique user, device, or company. The data is then formatted into an object array and passed to the 'userActivity' data property, which is then rendered in a bootstrap-vue table component.
     * @param {string} type - The type of device usage by user, device, or company.
     */
    getRecentUsage (type) {
      let self = this

      let urlType = ''

      if (type === 'USER') {
        urlType = '/by_user/' + this.$route.params.id
      } else if (type === 'DEVICE') {
        urlType = '/by_device/' + this.$route.params.id
      } else if (type === 'COMPANY') {
        urlType = '/by_company/' + this.$route.params.id
      }

      axios.get(`${process.env.VUE_APP_API_URL}api/visits/recent_usage${urlType}`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data

          let newData = []

          for (let i = 0; i < data.length; i++) {
            newData.push({
              user: {
                // name: data[i].first_name + ' ' + data[i].last_name,
                name: self.admin.level <= 1 ? data[i].first_name + ' ' + data[i].last_name : '*******',
                registered: data[i].date_created,
                new: data[i].times_used <= 1
              },
              usage: { times_used: data[i].times_used },
              activity: data[i].last_used
            })
          }

          self.userActivity = newData
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
